export const documentNumberMasks = {
  CL: '99999999-9'
}

export const phoneNumbersMasks = {
  CL: '+56999999999'
}
